import { supabase } from "@/lib/supabase";

const GAS_STATIONS_BUCKET = "GasStations";

function sanitizeFileName(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "logo";
  return trimmed.replace(/[^\w.\-]+/g, "_");
}

export function getGasStationStoragePublicUrl(objectPath: string): string {
  const { data } = supabase.storage.from(GAS_STATIONS_BUCKET).getPublicUrl(objectPath);
  return data.publicUrl;
}

export async function uploadGasStationBrandLogo(brandId: string, file: File): Promise<string> {
  const objectPath = `Logos/${brandId}/${sanitizeFileName(file.name)}`;
  const { error } = await supabase.storage.from(GAS_STATIONS_BUCKET).upload(objectPath, file, {
    upsert: true,
    contentType: file.type || undefined,
  });

  if (error) throw error;
  return getGasStationStoragePublicUrl(objectPath);
}

export async function uploadGasStationLogo(stationId: number, file: File): Promise<string> {
  const objectPath = `stationLogos/${stationId}/${sanitizeFileName(file.name)}`;
  const { error } = await supabase.storage.from(GAS_STATIONS_BUCKET).upload(objectPath, file, {
    upsert: true,
    contentType: file.type || undefined,
  });

  if (error) {
    throw new Error(error.message || "Failed to upload station logo.");
  }
  return getGasStationStoragePublicUrl(objectPath);
}
